import { render } from "./ProductLightbox.vue?vue&type=template&id=0b4a6dc1&ts=true"
import script from "./ProductLightbox.vue?vue&type=script&lang=ts"
export * from "./ProductLightbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__